import React from 'react';
import styles from './css/Templates.module.scss';

export default function Backgrounds () {
  const backgrounds = [
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720023261/Templates/Rectangle_42262_2_jdqgei.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720023060/Templates/Rectangle_42262_zjasmw.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720023261/Templates/Rectangle_42262_2_jdqgei.png' },
    { src: 'https://res.cloudinary.com/dsg2ktuqk/image/upload/v1720023060/Templates/Rectangle_42262_zjasmw.png' }
  ];
  return (
    <div className={styles.container}>
      <div className={`${styles.templates__container}`}>
        <h1>3D Backgrounds</h1>
        <small>
          Get the inspiration you need and boost your creativity
        </small>
        <div className={styles.images}>
          {backgrounds.map((item, i) => {
            return (
              <img src={item.src} key={i} />
            )
          })}
        </div>
      </div>
    </div>
  )
}
